"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useScenario(selector) {
  const { item: scenario, ...rest } = useElement(
    WorkspaceElementType.Scenario,
    selector,
    (integrationApp) => selector ? integrationApp.scenario(selector) : void 0
  );
  return { scenario, ...rest };
}

export { useScenario };
